
import HttpClient from '../HttpService';

function getById(candidateId) {
    return HttpClient.get(`/candidates/${candidateId}`);
}

function create(data) {
    return HttpClient.post(`/candidates`, data);
}

function list(page, limit, data) {
    return HttpClient.post(`/candidates/list?page=${page}&limit=${limit}`, data);
}

function update(data) {
    return HttpClient.put(`/candidates/${data.id}`, data);
}

function destroy(candidateId) {
    return HttpClient.delete(`/candidates/${candidateId}`);
}

export default {
    list,
    destroy,
    create,
    update,
    getById
}
